import React, { useState, useEffect } from "react";

const PasswordGate = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [input, setInput] = useState("");
  const [error, setError] = useState("");

  const PASSWORD = "Autofiyai@123"; // <-- change this to your desired password

  useEffect(() => {
    // Prefer the new key with expiry
    const storedGate = localStorage.getItem("isAuthenticatedGate");
    if (storedGate) {
      try {
        const parsed = JSON.parse(storedGate);
        const isValid =
          parsed &&
          parsed.value === true &&
          typeof parsed.expiresAt === "number" &&
          Date.now() < parsed.expiresAt;
        if (isValid) {
          setIsAuthenticated(true);
          return;
        } else {
          // Expired or malformed, clean up
          localStorage.removeItem("isAuthenticatedGate");
        }
      } catch {
        localStorage.removeItem("isAuthenticatedGate");
      }
    }

    // Backward compatibility: migrate from old key if present
    const legacyAuth = localStorage.getItem("isAuthenticated");
    if (legacyAuth === "true") {
      const expiresAt = Date.now() + 24 * 60 * 60 * 1000; // 24 hours
      localStorage.setItem(
        "isAuthenticatedGate",
        JSON.stringify({ value: true, expiresAt })
      );
      localStorage.removeItem("isAuthenticated");
      setIsAuthenticated(true);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input === PASSWORD) {
      setIsAuthenticated(true);
      const expiresAt = Date.now() + 24 * 60 * 60 * 1000; // 24 hours
      localStorage.setItem(
        "isAuthenticatedGate",
        JSON.stringify({ value: true, expiresAt })
      );
      // Remove legacy key if it exists
      localStorage.removeItem("isAuthenticated");
    } else {
      setError("Incorrect password. Try again.");
    }
  };

  if (!isAuthenticated) {
    return (
      <div style={styles.container}>
        <form onSubmit={handleSubmit} style={styles.form}>
          <h2 style={styles.title}>🔐 Enter Access Password</h2>
          <p style={styles.subtitle}>
            To access <strong>autofiyai.com</strong>, please enter the access password.
          </p>
          <input
            type="password"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Enter password"
            style={styles.input}
          />
          <button type="submit" style={styles.button}>Unlock</button>
          {error && <p style={styles.error}>{error}</p>}
        </form>
      </div>
    );
  }

  return children;
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    background: "linear-gradient(135deg, #0b1a4a, #163b65 50%, #0f2a4f)"
  },
  form: {
    background: "rgba(15, 30, 60, 0.35)",
    backdropFilter: "blur(6px)",
    WebkitBackdropFilter: "blur(6px)",
    padding: "28px",
    borderRadius: "10px",
    textAlign: "center",
    boxShadow: "0 10px 30px rgba(0,0,0,0.35)",
    border: "1px solid rgba(255,255,255,0.12)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  title: { color: "#ffffff", margin: "0 0 6px 0" },
  subtitle: { color: "rgba(255,255,255,0.8)", margin: "0 0 14px 0", fontSize: "14px" },
  input: {
    padding: "10px",
    width: "200px",
    borderRadius: "5px",
    border: "1px solid rgba(255,255,255,0.25)",
    background: "rgba(255,255,255,0.9)",
    marginBottom: "10px",
  },
  button: {
    padding: "10px 20px",
    borderRadius: "5px",
    border: "none",
    background: "#3182ce",
    color: "#fff",
    cursor: "pointer",
    transition: "background 0.2s ease",
    marginTop: "8px",
    width: "200px",
  },
  error: {
    color: "red",
    marginTop: "10px",
  },
};

export default PasswordGate;
